import {getPaymentLink} from "@/api/Orders/GetPaymentLink";
import {createOrder} from "@/api/Orders/CreateOrder";
import {getOrderStatusByCourseId} from "@/api/Orders/GetOrderStatusByCourseId";
import {getOrderStatus} from "@/api/Orders/GetOrderStatus";

export default {
    actions: {
        fetchPaymentLink: async ({commit}, {locationId, orderIdentifier, origin, customersCourseToExtendId}) => {
            const paymentLink = await getPaymentLink(locationId, orderIdentifier, origin, customersCourseToExtendId)
            return paymentLink.data
        },
        createOrder: async ({commit}, {locationId, productId, greenCourseId, isCourseExtension = false}) => {
            const order = await createOrder(locationId, productId, greenCourseId, isCourseExtension);
            return order.data
        },
        getOrderStatus: async ({commit}, {orderIdentifier}) => {
            const status = await getOrderStatus(orderIdentifier)
            return status.data
        },
        getOrderStatusByCourseId: async ({commit}, {courseId}) => {
            console.log("courseEndedView", courseId)
            const status = await getOrderStatusByCourseId(courseId)
            return status.data
        }
    }
}

